import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Config from '../config/'

Vue.use(Config)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
axios.defaults.withCredentials = true
axios.defaults.headers.common.Accept = 'application/json'

export default new Vuex.Store({
  state: {
    games: [],
    providers: [],
    userData: null,
    messages: [],
    flashMessages: null,
    depositMethods: [],
    depositSettings: null,
    withdrawMethods: {},
    depositHistory:null,
    lastWithdrawHistory:null,
    tipData:{},
    socialLinks:{},
    winners: null,
    gameWinners: null,
    wheelStats: null,
    aliveGames: null,
    balance: 0,
    terms:null,
    activeBonuses: null,
    levels: null,
    userDataFetched: false,
    userIdentityData : null,
    mainSettings : {},
    onHoldTransfers: null,
    onHoldTransfersAmount: null,
    clientsLevel: null,
    uDepSum: null,
    enableWaitingWithdrawModal: 0,
    freeRound: null,
    freespins: [],
    slides: null,
    vipWithdrawalText: '',
    vipWithdrawalPercent: null,
    enabledRegistration: false
  },

  actions: {

    async fetchUserData (context, update = false) {
      context.commit('setUserDataFetched', false)
      return new Promise((resolve) => {
        axios.get(
          Config.baseUrl + '/Api/getUserInfo/'+update,
            {
              crossdomain: true
            }
        ).then(({ data }) => {
          if (data.data) {
            let response = data.data
            let uData = null
            if (response.userData) {
              uData = response.userData
              window.UserInfo = { id: uData.id, login: uData.login }
            }
            context.commit('setUserData', uData)
            resolve(data.data)
            context.commit('setUserDataFetched' ,true)
          }
        }) .catch(err => {
          console.log(err)
        })
      })
    },

    fetchApiData(context) {
      axios.get(Config.baseUrl + '/Api/apiData', {crossdomain: true})
        .then((resp) => {
          const apiData = resp.data.data.combinedData
          context.commit('setClientsLevels', apiData.levels)
          context.commit('setuDepSum', apiData.uDepSum)
          context.commit('setMessages', apiData.messages)
          context.commit('setDepositMethods', apiData.payMethods.availableMethods)
          context.commit('setDepositSettings', apiData.payMethods.settings)
          context.commit('setMainSettings', apiData.mainSettings)
          context.commit('setWithdrawMethods', apiData.withdrawMethods)
          context.commit('setTipData', apiData.tipData)
          context.commit('setSocialLinks', apiData.socialLinks)
          context.commit('setWinnersList', apiData.winners),
          context.commit('setEnableWaitingWithdrawModal', apiData.enableWaitingWithdrawModal)
          context.commit('setFreespins', apiData.freespins)
          context.commit('setSlides', apiData.slides)
          context.commit('setVipWithdrawalText', apiData.vipWithdrawalsText)
          context.commit('setVipWithdrawalPercent', apiData.vipWithdrawalsPercent)
          context.commit('setEnabledRegistration', apiData.enabledRegistration)
        }).catch(err => {
        console.log(err.message)
      })
    },

    removeUserData (context) {
      context.commit('removeUserData')
    },

    logoutUser(context) {
      axios.get(
        Config.baseUrl + '/Api/logout',
        {
          crossdomain: true
        }
      ).then(() => {
        context.commit('removeUserData')
        window.location.reload(true)
      }).catch(err => {
        console.log(err)
      })
    },

    async getMainSettings(context) {
      await axios.get(
        Config.baseUrl + '/Api/getMainSettings',
        {
          crossdomain: true
        }
      ).then(({ data }) => {
        if (data.data) {
          let response = data.data
          context.commit('setMainSettings', response)
        }
      })
    },
    dispatchUserBalance (context, balance) {
      context.commit('setUserBalance', balance)
    },
    checkForAliveGame (context) {
      return new Promise((resolve) => {
        axios.get(
          Config.baseUrl + '/Api/checkForAliveGame', {
            crossdomain: true
          }
        ).then(({ data }) => {
          if (data.data) {
            context.commit('setAliveGames', data.data)
            resolve(data.data)
          }
        }).catch(err => {
          console.log(err.message)
        })
      })
    },
    getWithdrawHistory(context) {
      axios.get(
        Config.baseUrl + '/Api/withdrawHistory'
      ).then(({data}) => {
        if (data.status === 'ok') {
          if (data.data) {
            context.commit('setLastWithdrawHistory', data.data.lastWithdraw)
          }
        }
      })
    },
    getDepositHistory(context) {
      axios.get(
        Config.baseUrl + '/Api/depositHistory'
      ).then(({data}) => {
        if (data.status === 'ok') {
          if (data.data) {
            context.commit('setDepositHistory', data.data.lastDeposit)

          }
        }
      })
    },
    getTerms(context) {
      axios.get(
        Config.baseUrl + '/Api/getTerms'
      ).then(({data}) => {
        if (data.status === 'ok') {
          if (data.data) {
            context.commit('setTerms', data.data.terms)

          }
        }
      })
    },
    fetchMessages (context) {
      try {
        axios.get(Config.baseUrl + '/Api/getMessages')
          .then((resp) => {
            context.commit('setMessages', resp.data.data)
          }).catch(err => {
            console.log(err.message)
          })
      } catch (err) {
        console.log(err.message)
      }
    },

    fetchFlashMessages (context) {
      axios.get(
        Config.baseUrl + '/Api/getFlashMessages'
      ).then(({ data }) => {
        if (data.status === 'ok') {
          if (data.data) {
            context.commit('setFlashMessages', data.data)
          }
        }
      })
    },

    unsetFlashMessages (context) {
      axios.get(Config.baseUrl + '/Api/unsetFlashMessages'
      ).then(() => {
        context.commit('setFlashMessages', null)
      })
    },

    fetchUserIdentityData (context) {
      try {
        return new Promise((resolve) => {
          axios.get(Config.baseUrl + '/Api/getUserIdentityData')
            .then((resp) => {
              if (resp.data.status === 'ok') {
                context.commit('setUserIdentityData', resp.data.data.identityData)
              }
            }).catch(err => {
            console.log(err.message)
          })
          resolve()
        })
      } catch (err) {
        console.log(err.message)
      }
    },
    fetchGameWinners (context, data) {
      try {
        axios.get(Config.baseUrl + '/Api/getGameWinners/' + data.provider + '/' + data.gameId)
          .then((resp) => {
            context.commit('setGameWinners', resp.data)
          }).catch(err => {
            console.log(err.message)
          })
      } catch (err) {
        console.log(err.message)
      }
    },

    fetchWheelStatistic (context) {
      try {
        axios.get(Config.baseUrl + '/Api/getWheelStats')
          .then((resp) => {
            context.commit('setWheelStats', resp.data)
          }).catch(err => {
            console.log(err.message)
          })
      } catch (err) {
        console.log(err.message)
      }
    },

    fetchFreeRoundsOnGameLaunch (context, data) {
      try {
        axios.post(
          Config.baseUrl + '/Api/checkUserFreeRound',
          data
        ).then((resp) => {
            console.log(resp)
          }).catch(err => {
          console.log(err.message)
        })
      } catch (err) {
        console.log(err.message)
      }
    },

    fetchGames(context) {
      axios.get(Config.baseUrl + '/Api/gamesList', {crossdomain: true})
          .then((resp) => {
            const answer = resp.data
            if (answer.status && answer.status === 'ok') {
              context.commit('setGames', answer.data)
              context.commit('setProviders', answer.data)
            }
          }).catch(err => {
        console.log(err.message)
      })
    },

    fetchGamesByProviders(context, provider) {
      try {
        axios.post(
            Config.baseUrl + '/Api/gamesListByProviders',
            {'provider': provider}
        ).then((resp) => {
          const answer = resp.data
          if(answer.status == "ok") {
            context.commit('setGamesv2', answer.data)
          }
        }).catch(err => {
          console.log(err.message)
        })
      } catch (err) {
        console.log(err.message)
      }
    },

    fetchBonuses(context){
      try {
        axios.post(
            Config.baseUrl + '/Api/getActiveBonuses'
        ).then((resp) => {
          const answer = resp.data
          if(answer.status == "ok") {
            context.commit('setActiveBonuses', answer.data.bonuses)
          }
        }).catch(err => {
          console.log(err.message)
        })
      } catch (err) {
        console.log(err.message)
      }
    },
    checkUserFreeRound(context) {
      return new Promise((resolve) => {
        axios.get(
            Config.baseUrl + '/Api/checkUserFreeRoundNew', {
              crossdomain: true
            }
        ).then(({data}) => {
          if (data.data) {
            context.commit('setFreeRound', data.data)
            resolve(data.data)
          }
        }).catch(err => {
          console.log(err.message)
        })
      })
    }
  },

  mutations: {
    setActiveBonuses (state, bonuses) {
      state.activeBonuses = bonuses
    },
    setGames (state, data) {
      state.games = data.games
    },
    setGamesv2(state, data) {
      state.games[data.provider].games = data.games;
    },
    setProviders (state, data) {
      state.providers = data.providers
    },
    setUserData (state, user) {
      state.userData = user
    },
    setTerms (state, terms) {
      state.terms = terms
    },
    setUserDataFetched (state, fetched) {
      if (fetched) {
        state.userDataFetched = true
      }
    },
    setDepositHistory(state, depositHistory) {
      state.depositHistory = depositHistory
    },
    setLastWithdrawHistory(state, withdrawHistory) {
      state.lastWithdrawHistory = withdrawHistory
    },
    removeUserData (state) {
      state.userData = null
    },
    setMessages (state, msgs) {
      state.messages = msgs
    },
    setFlashMessages (state, params) {
      state.flashMessages = params
    },
    setDepositMethods (state, methods) {
      state.depositMethods = methods
    },
    setVipWithdrawalText (state, text) {
      state.vipWithdrawalText = text
    },
    setVipWithdrawalPercent (state, percent) {
      state.vipWithdrawalPercent = percent
    },
    setDepositSettings (state, data) {
      state.depositSettings = data
    },
    setClientsLevels (state ,levels) {
      Vue.set(state, 'clientsLevel', levels)
    },
    setuDepSum (state, uDepSum) {
      Vue.set(state, 'uDepSum', uDepSum)
    },
    setWithdrawMethods (state, withdrawMethods) {
      state.withdrawMethods = {
        regular: [],
        vip: []
      };
      for(var i = 0; i < withdrawMethods.length; i++){
        if (withdrawMethods[i].is_vip == 0) {
          state.withdrawMethods.regular.push(withdrawMethods[i]);
        } else {
          state.withdrawMethods.vip.push(withdrawMethods[i]);
        }
      }
    },
    setTipData (state, history) {
      state.tipData = history
    },
    setSocialLinks (state, socialLinks) {
      state.socialLinks = socialLinks
    },
    setEnableWaitingWithdrawModal (state, enableWaitingWithdrawModal) {
      state.enableWaitingWithdrawModal = enableWaitingWithdrawModal
    },
    setWinnersList (state, winners) {
      state.winners = winners
    },
    setGameWinners (state, winners) {
      state.gameWinners = winners.data.winners
    },
    setWheelStats (state, stats) {
      state.wheelStats = stats.data
    },
    setUserBalance (state, balance) {
      state.balance = balance
    },
    setAliveGames (state, data) {
      if (data) {
        state.aliveGames = data.aliveGames
      }
    },
    setUserIdentityData(state, identityData) {
      state.userIdentityData = identityData
    },
    setMainSettings(state, settings) {
      state.mainSettings = settings
    },
    setFreeRound(state, data) {
      if (data && data.id) {
        state.freeRound = data
      }else{
        state.freeRound = null
      }
    },
    setFreespins (state, freespins) {
      state.freespins = freespins
    },
    setSlides(state, slides) {
      state.slides = slides
    },
    setEnabledRegistration (state, enabledRegistration) {
      state.enabledRegistration = enabledRegistration
    },
  },

  getters: {
    games (state) {
      return state.games
    },
    providers (state) {
      return state.providers
    },
    userData (state) {
      if (state.userData) {
        return state.userData
      }
      return null
    },
    userDataFetched (state) {
      return state.userDataFetched
    },
    messages (state) {
      try {
        return state.messages
      } catch (err) {
        console.log(err.message)
      }
    },
    getFlashMessages (state) {
      return state.flashMessages
    },
    newMessages (state) {
      return state.messages.filter(i => !i.viewed)
    },
    getDepositMethods (state) {
      try {
        return state.depositMethods
      } catch (err) {
        console.log(err.message)
      }
    },
    getDepositSettings (state) {
      try {
        return state.depositSettings
      } catch (err) {
        console.log(err.message)
      }
    },
    getWithdrawMethods (state) {
      try {
        return state.withdrawMethods
      } catch (err) {
        console.log(err.message)
      }
    },
    getDepositHistory(state) {
      try {
        return state.depositHistory
      } catch (err) {
        console.log(err.message)
      }
    },
    getLastWithdrawHistory(state) {
      try {
        return state.lastWithdrawHistory
      } catch (err) {
        console.log(err.message)
      }
    },
    getWinnersList (state) {
      return state.winners
    },
    getGameWinner (state) {
      return state.gameWinners
    },
    getWheelStats (state) {
      try {
        if (state.wheelStats !== null) {
          if (state.wheelStats.hasOwnProperty('profitBorder') && state.wheelStats.hasOwnProperty('lastMonthDeposit')) {
            const progressPercent = (state.wheelStats.lastMonthDeposit /state.wheelStats.profitBorder) * 100
            if(parseInt(progressPercent) > 100){
              state.wheelStats.progressPercent = 100
            }else{
              state.wheelStats.progressPercent = parseInt(progressPercent)
            }
          } else {
            state.wheelStats.progressPercent = 0
          }
        }
        return state.wheelStats
      } catch (e) {
        console.log(e.messages)
      }
    },
    aliveGames (state) {
      return state.aliveGames
    },
    balance (state) {
      return state.balance
    },
    terms (state) {
      return state.terms
    },
    getActiveBonuses (state) {
      return state.activeBonuses
    },
    identityData (state) {
      return state.userIdentityData
    },
    getMainSettings (state) {
      return state.mainSettings
    },
    clientsLevel (state) {
      return state.clientsLevel
    },
    uDepSum (state) {
      return state.uDepSum
    },
    getTipData (state) {
      return state.tipData
    },
    getSocialLinks (state) {
      return state.socialLinks
    },
    getEnableWaitingWithdrawModal (state) {
      return state.enableWaitingWithdrawModal
    },
    freeRound(state) {
      return state.freeRound
    },
    getFreespins(state) {
      return state.freespins
    },
    getSlides (state) {
      return state.slides
    },
    getVipWithdrawalText (state) {
      return state.vipWithdrawalText
    },
    getVipWithdrawalPercent (state) {
      return state.vipWithdrawalPercent
    },
    getEnabledRegistration (state) {
      return state.enabledRegistration
    },
  }
})
